import { createSelector } from 'reselect';

import { RootModel } from '../models';
import { FloorTypes } from '../../types';

export const getSelectedFloor = createSelector<
  RootModel,
  { [key: string]: FloorTypes },
  number,
  FloorTypes
>(
  (state) => state.floorEntity.ids,
  (state) => state.sitePlanModel.floorId,
  (ids, id) => ids[id]
);
